/* COMPONENT IMPORTS*/
import Home from "../pages/Home/Home";
import Profile from "../pages/Profile/Profile";
import Poupanca from "../pages/Poupanca/Poupanca";
import Protecao from "../pages/Protecao/Protecao";
import ProtecaoPoupanca from "../pages/ProtecaoPoupanca/ProtecaoPoupanca";
import Beneficios from "../pages/Beneficios/Beneficios";
import AdicionaMenor from "../pages/AdicionaMenor/AdicionaMenor";
import Correio from "../pages/Correio/Correio";
import Eleicoes from "../pages/Eleicoes/Eleicoes";
import { CartaoAssociado } from "../pages/CartaoAssociado/CartaoAssociado";
import { Notifications } from "../pages/Notifications/Notifications";
import { Fees } from "../pages/Fees/Fees";
import { MaioridadePage } from "./RepresentativeResponse/MaioridadePage";
import { HealthPage } from "../pages/Health";

/*import PopupContainer from './Popups/PopupContainer';*/

import ContextConstructor from "./Context/Context";
import ProtectedRoute from "../ProtectedRoute";
/* MODULE IMPORTS */
import React, { Component, Suspense } from "react";
import { Route, Redirect } from "react-router-dom";

/* CSS IMPORT */
import "../custom.css";

const DesignSystemPreviewPage = React.lazy(
  () => import("../designSystem/previews/DesignSystemPreview"),
);

class RouteRuler extends Component {
  static displayName = RouteRuler.name;

  render() {
    //console.log("RouteRuler context ", this.context)

    let Maioridade = this.context.selectedUser.age >= 18 ? true : false;
    let isRepresentado = this.context.selectedUser.associateId ? true : false;
    // Get isElectionsTime from context
    let isElectionsTime = this.context.isElectionsTime;

    if (Maioridade === true && isRepresentado === true) {
      return (
        <React.Fragment>
          <Redirect to="/MaioridadePage" />
          <Route exact path="/profile" component={ProtectedRoute(Profile)} />
          <Route exact path="/AdicionaMenor" component={ProtectedRoute(AdicionaMenor)} />
          <Route exact path="/notificacoes" component={ProtectedRoute(Notifications)} />
          <Route exact path="/MaioridadePage" component={ProtectedRoute(MaioridadePage)} />
          <Redirect to="/MaioridadePage" />
        </React.Fragment>
      );
    } else if (this.context.selectedUser.associateState === "CONDICIONADO") {
      return (
        <React.Fragment>
          <Route exact path="/fees" component={ProtectedRoute(Fees)} />
          <Redirect to="/fees" />
          <Route exact path="/profile" component={ProtectedRoute(Profile)} />
          <Route exact path="/AdicionaMenor" component={ProtectedRoute(AdicionaMenor)} />
          <Route exact path="/notificacoes" component={ProtectedRoute(Notifications)} />
        </React.Fragment>
      );
    } else if (
      this.context.selectedUser.associateState === "NOTASSOCIATE" ||
      this.context.selectedUser.status === "NATIVO"
    ) {
      return (
        <React.Fragment>
          <Route exact path="/" component={Home} />
          <Route exact path="/profile" component={ProtectedRoute(Profile)} />
          <Route exact path="/AdicionaMenor" component={ProtectedRoute(AdicionaMenor)} />
          <Route exact path="/notificacoes" component={ProtectedRoute(Notifications)} />
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <Route exact path="/" component={ProtectedRoute(Home)} />
          <Route exact path="/profile" component={ProtectedRoute(Profile)} />
          <Route exact path="/poupanca" component={ProtectedRoute(Poupanca)} />
          <Route exact path="/protecao" component={ProtectedRoute(Protecao)} />
          <Route exact path="/protecao_poupanca" component={ProtectedRoute(ProtecaoPoupanca)} />
          <Route exact path="/beneficios" component={ProtectedRoute(Beneficios)} />
          <Route exact path="/cartaoassociado" component={ProtectedRoute(CartaoAssociado)} />
          <Route exact path="/fees" component={ProtectedRoute(Fees)} />
          <Route exact path="/notificacoes" component={ProtectedRoute(Notifications)} />
          <Route exact path="/correio" component={ProtectedRoute(Correio)} />
          <Route exact path="/AdicionaMenor" component={ProtectedRoute(AdicionaMenor)} />
          {isElectionsTime && <Route exact path="/eleicoes" component={ProtectedRoute(Eleicoes)} />}
          <Route exact path="/saude" component={ProtectedRoute(HealthPage)} />
          {process.env.NODE_ENV === "development" && (
            <Suspense fallback={null}>
              <Route
                exact
                path="/dev/design-system"
                component={ProtectedRoute(DesignSystemPreviewPage)}
              />
            </Suspense>
          )}
        </React.Fragment>
      );
    }
  }
}

//Add the context to the Component
RouteRuler.contextType = ContextConstructor;

export default RouteRuler;
